// import inbound from 'inbound';
import { parse } from 'query-string';

/**
 * parse referrer and querystring for tracking
 * @see {@link https://docs.google.com/spreadsheets/d/1A2nZX4XhYauCy96MC60791RjGdBVa-aiTHbnxcPlMa8/edit#gid=728817929}
 */
export const getLinkTracking = () => {

  const url = window.location.href;
  const referrer = document.referrer;
  const query = parse(window.location.search);
  
  // utm
  const utm = {
    utm_campaign: query['utm_campaign'],
    utm_content: query['utm_content'],
    utm_source: query['utm_source'],
    utm_medium: query['utm_medium'],
    utm_term: query['utm_term'],
  }

  // branch_link 
  const branch_link = window.location.search.includes('branch_match') ? 'branch_link' : null;

  // referrer
  let referrerObj = {
    // referrer_source: 'linetv_web',
    // referrer_medium: 'referral',
  }
  // inbound.referrer.parse(url, referrer, (err, desc) => {
  //   if (err) {
  //     console.error(err);
  //     return;
  //   }
    
  //   console.log('desc:', desc);
  //   if (desc.referrer.type === 'social') {
  //     referrerObj['referrer_source'] = desc.referrer.network;
  //     referrerObj['referrer_medium'] = 'referral';
  //   }
  //   if (desc.referrer.type === 'search') {
  //     referrerObj['referrer_source'] = desc.referrer.engine;
  //     referrerObj['referrer_medium'] = 'organic';
  //   }
  //   if (desc.referrer.type === 'direct') {
  //     referrerObj['referrer_source'] = 'direct';
  //     referrerObj['referrer_medium'] = 'none';
  //   }
  // });
  
  // referring_link
  const domain = referrer.match(/^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/im) || [];

  const tracking = {
    ...utm,
    utm_campaign: utm.utm_campaign || branch_link,
    utm_source: utm.utm_source || referrerObj.referrer_source,
    utm_medium: utm.utm_medium || referrerObj.referrer_medium,
    referring_link: domain[1] || 'direct',
  }
  return tracking;
}
